export default __webpack_public_path__ + "static/media/time-to-guess-title.b5b81231.webp";